import {
    n670,
    n400,
    n200,
    white,
    g400,
    gm400,
  } from '@aab/sc-styles-colors';

export const p = `
  p {
    font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
    margin-top: 0;
    margin-bottom: 1rem;
    line-height: 1.5;
    color: ${n670};
  }
`;

export const label = `
  label {
    font-family: "Roboto Medium", "Helvetica Neue", Arial, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${gm400};
  }
`;

export const h1 = `
  h1,
  .h1 {
    font-family: "Roboto Condensed", "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 3.5rem;
    line-height: 4rem;
    color: ${n670};
  }

  @media only screen and (max-width: 576px) {
    h1,
    .h1 {
      font-size: 2.5rem;
      line-height: 3rem;
      color: ${n670};
    }
  }
`;

export const h2 = `
  h2,
  .h2 {
    font-family: "Roboto Condensed", "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 2rem;
    line-height: 2.5rem;
    color: ${n670};
  }

  @media only screen and (max-width: 576px) {
    h2,
    .h2 {
      font-size: 1.75rem;
      line-height: 2rem;
      color: ${n670};
    }
  }
`;

export const h3 = `
  h3,
  .h3 {
    font-family: "Roboto Condensed", "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: 2rem;
    color: ${n670};
  }

  @media only screen and (max-width: 576px) {
    h3,
    .h3 {
      font-size: 1.25rem;
      line-height: 1.5rem;
      color: ${n670};
    }
  }
`;

export const h4 = `
  h4,
  .h4 {
    font-family: "Roboto Medium", "Helvetica Neue", Arial, sans-serif;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    line-height: 1.5rem;
    color: ${n670};
  }

  @media only screen and (max-width: 576px) {
    h4,
    .h4 {
      font-size: 1.125rem;
      line-height: 1.5rem;
      color: ${n670};
    }
  }
`;

export const text_small = `
  .text-small {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`;

export const text_intro = `
  .text-intro {
    font-size: 1.25rem;
    line-height: 32px;
  }
`;

export const text_green = `
  .text-green {
    color: ${g400} !important;
  }
`;

export const text_gray = `
  .text-gray {
    color: ${n400} !important;
  }
`;

export const text_light_gray = `
  .text-light-gray {
    color: ${n200} !important;
  }
`;

export const text_white = `
  .text-white {
    color: ${white} !important;
  }
`;

export default {
  p: p,
  label: label,
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  text_small: text_small,
  text_intro: text_intro,
  text_green: text_green,
  text_gray: text_gray,
  text_light_gray: text_light_gray,
  text_white: text_white,
};
